// --------------- type model interface 抽象的名詞

// eslint-disable-next-line max-classes-per-file
export interface PersonalInformationModel {
  name: string;
  postcode: string;
  address: string;
  phone: string;
  telephone: string;
  email: string;
  line: string;
  wechat: string;
  informMethod: string;
}

export interface LongevityBoardModel {
  streamId: string; // e.g. 15_2 15_3
  name: string;
}

export interface PrayBoardModel {
  registerName: string;
  prayType: string;
  otherPrayType: string;
  prayDetail: string;
  streamId: string;
}

export interface AttendInfoModel {
  name: string;
  gender: string;
  age: string;
  attendDate: string;
  attendTime: string;
  leaveDate: string;
  leaveTime: string;
  note: string;
  timestamp: string;
}

export interface CeremonyFormModel {
  personalInformation: PersonalInformationModel;
  longevityBoards: Array<LongevityBoardModel>;
  prayBoards: Array<PrayBoardModel>;
  attendInfoList: Array<AttendInfoModel>;
}

// --------------- class object 實體化的名詞 會動的

export class PersonalInformation implements PersonalInformationModel {
  name: string;

  postcode: string;

  address: string;

  phone: string;

  telephone: string;

  email: string;

  line: string;

  wechat: string;

  informMethod: string;

  constructor(name = '', postcode = '', address = '', phone = '', telephone = '', email = '', line = '', wechat = '', informMethod = '') {
    this.name = name;
    this.postcode = postcode;
    this.address = address;
    this.phone = phone;
    this.telephone = telephone;
    this.email = email;
    this.line = line;
    this.wechat = wechat;
    this.informMethod = informMethod;
  }
}

export class LongevityBoard implements LongevityBoardModel {
  streamId: string;

  name: string;

  constructor(name: string) {
    this.name = name;
    this.streamId = '';
  }
}

export class PrayBoards implements PrayBoardModel {
  registerName: string;

  prayType: string;

  otherPrayType: string;

  prayDetail: string;

  streamId: string;

  constructor(registerName: string, prayType: string, otherPrayType: string, prayDetail: string) {
    this.registerName = registerName;
    this.prayType = prayType;
    this.otherPrayType = otherPrayType;
    this.prayDetail = prayDetail;
    this.streamId = '';
  }
}

export class AttendInfo implements AttendInfoModel {
  name: string;

  gender: string;

  age: string;

  attendDate: string;

  attendTime: string;

  leaveDate: string;

  leaveTime: string;

  note: string;

  timestamp: string;

  constructor(name: string, gender: string, age: string, attendDate: string, attendTime: string, leaveDate: string, leaveTime: string, note: string, timestamp: string) {
    this.name = name;
    this.gender = gender;
    this.age = age;
    this.attendDate = attendDate;
    this.attendTime = attendTime;
    this.leaveDate = leaveDate;
    this.leaveTime = leaveTime;
    this.note = note;
    this.timestamp = timestamp;
  }
}

export class CeremonyForm implements CeremonyFormModel {
  personalInformation: PersonalInformationModel;

  longevityBoards: LongevityBoardModel[];

  prayBoards: PrayBoardModel[];

  attendInfoList: AttendInfoModel[];

  constructor() {
    this.personalInformation = new PersonalInformation();
    this.longevityBoards = [new LongevityBoard('')];
    this.prayBoards = [new PrayBoards('', '', '', '')];
    this.attendInfoList = [new AttendInfo('', '', '', '', '', '', '', '', '')];
  }
}
